import {
  FormControl,
  FormDescription,
  FormItem,
  FormLabel,
  FormMessage,
  FormField,
} from '@/components/ui/form';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { cn } from '@/lib/utils';
import React from 'react';
import { FieldPathByValue, FieldValues } from 'react-hook-form';

import { FieldOptions, FieldProps } from './shared';

export function RadioField<
  T extends FieldValues,
  P extends FieldPathByValue<T, string>,
>({
  control,
  name,
  rules,
  label,
  description,
  className,
  options,
  ...props
}: FieldProps<T, P> &
  React.ComponentPropsWithoutRef<typeof RadioGroup> &
  FieldOptions) {
  return (
    <FormField
      control={control}
      name={name}
      rules={rules}
      render={({ field: { value, onChange, ...field } }) => (
        <FormItem className="grow">
          <div className="mb-4">
            <FormLabel>{label}</FormLabel>
            <FormDescription>{description?.(value)}</FormDescription>
          </div>
          <FormControl>
            <RadioGroup
              className="flex flex-col"
              value={String(value ?? '')}
              onValueChange={onChange}
              {...props}
              {...field}
            >
              {options.map((option) => (
                <FormItem
                  key={option.id}
                  className={cn(
                    'flex items-center py-1 space-x-3 space-y-0',
                    className
                  )}
                >
                  <FormControl>
                    <RadioGroupItem value={option.id} />
                  </FormControl>
                  <FormLabel className="font-normal">{option.label}</FormLabel>
                </FormItem>
              ))}
            </RadioGroup>
          </FormControl>
          <FormMessage />
        </FormItem>
      )}
    />
  );
}
